import i18n from "@/plugins/vue-i18n";
import {
  languages,
  browsers,
  hours,
  days,
  distributions,
  pricingModels,
  statuses,
  optimizationActions,
  mimeTypes,
  playerSizes,
} from "@/data/campaign";

import { trafficTypes, operationSystems } from "@/data/common";
import { camelCase } from "lodash";
import MacroApi from "@/api/macros";

export default {
  namespaced: true,

  state: {
    trafficTypes,
    languages,
    browsers,
    operationSystems,
    distributions,
    hours,
    days,
    pricingModels,
    statuses,
    optimizationActions,
    mimeTypes: mimeTypes,
    playerSizes,

    statusColors: {
      pending: "jaffa",
      approved: "jungle-green",
      disapproved: "burnt-sienna",
      disabled: "fc-stroke",
    },

    macros: [],

    geoCountries: [],
    geoRegions: [],
    geoCities: [],

    weekends: ["saturday", "sunday"],
  },

  getters: {
    pricingModelOptions(state, getters, rootState, rootGetters) {
      const isAdmin = rootGetters["user/isAdmin"];

      return state.pricingModels
        .filter((code) => {
          let result = true;

          // INFO: rnd-2493-cpa-goal-option
          if (!isAdmin && code === "CPAg") result = false;

          return result;
        })
        .map((code) => ({
          code,
          label: i18n.t(`campaign.pricingModel.${code}`),
        }));
    },

    languageOptions(state) {
      return state.languages.map((code) => ({
        code,
        label: i18n.t(`campaign.language.${code}`),
      }));
    },

    browserOptions(state) {
      return state.browsers.map((code) => ({
        code,
        label: i18n.t(`campaign.browser.${camelCase(code)}`),
      }));
    },

    distributionOptions(state) {
      return state.distributions.map((code) => ({
        code,
        label: i18n.t(`campaign.distribution.${code}`),
      }));
    },

    hourList(state) {
      return state.hours.map((code) => ({
        code,
        label: i18n.t(`campaign.hour.${code}`),
      }));
    },

    dayList(state) {
      return state.days.map((code) => ({
        code,
        label: i18n.t(`campaign.day.${code}`),
      }));
    },

    statusOptions(state) {
      return state.statuses.map((code) => ({
        code,
        label: i18n.t(`campaign.status.${camelCase(code)}`),
      }));
    },

    macrosOptions(state) {
      return state.macros.map(({ code, label }) => ({
        code: `[${code}]`,
        label,
      }));
    },

    optimizationActionOptions(state) {
      return state.optimizationActions.map((code) => ({
        code,
        label: i18n.t(`campaign.optimizationActions.${code}`),
      }));
    },

    mimeTypeOptions(state) {
      return state.mimeTypes.map((code) => ({
        code,
        label: i18n.t(`campaign.mimeTypes.${code}`),
      }));
    },

    playerSizeOptions(state) {
      return state.playerSizes.map((code) => ({
        code,
        label: i18n.t(`campaign.playerSizes.${code}`),
      }));
    },

    statusColorsList(state) {
      return state.statusColors;
    },
  },

  mutations: {
    SET_MACROS(state, macros) {
      state.macros = macros;
    },
  },

  actions: {
    async getMacros(context) {
      if (!context.state.macros.length) {
        const response = await MacroApi.all();

        context.commit("SET_MACROS", response);
      }
    },
  },
};
